export const FETCH_DATA = 'myaxa/contento/fetchData';

export const initialState = {
  header: {
    en: {},
    zh: {},
  },
  footer: {
    en: {},
    zh: {},
  },
  dmsPolicyRemark: {
    en: {},
    zh: {},
  },
};

export default function contentoReducer(state = initialState, action = {}) {
  if (action.type === FETCH_DATA) {
    return { ...state, ...action.data };
  }
  return state;
}
